import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import { completeMyHoursLogin } from '../lib/federation';
import { afterLoginTarget } from '../lib/afterLoginTarget';
import { useAuth } from '../lib/AuthContext';

/** Rückkehr von "Mit MyHours-Konto anmelden": Code gegen Tokens tauschen, dann zum Ziel. */
export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState<string>();
  // StrictMode ruft Effekte doppelt auf; der Code ist nur einmal einlösbar.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    completeMyHoursLogin(window.location.search)
      .then(async (target) => {
        await refresh();
        navigate(afterLoginTarget({ from: target }), { replace: true });
      })
      .catch((err: unknown) =>
        setError(err instanceof Error ? err.message : 'Anmeldung fehlgeschlagen'),
      );
  }, [navigate, refresh]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 8, px: 2 }}>
      {error ? (
        <Stack spacing={2} sx={{ maxWidth: 480 }}>
          <Alert severity="error">{error}</Alert>
          <Button variant="contained" onClick={() => navigate('/login', { replace: true })}>
            Zur Anmeldung
          </Button>
        </Stack>
      ) : (
        <CircularProgress />
      )}
    </Box>
  );
}
